import axios from 'axios'
import moment from 'moment'
import { Message } from 'element-ui';

var stiltInfo = {
  "name": "stilt",
  "label": "stilt",
  "value": "stilt",
  "decimal": 0,
  "unit": "",
  "color_range_min": 0,
  "color_range_max": 1,
  "default_bar_type": "gradient",
  "colors": [
      {
          "name": "标准色带",
          "value": "static",
          "show_max_num": 1,
          "show_desc": 1,
          "data": [
              {
                  "level": 1,
                  "min": 0,
                  "max": 10,
                  "bgcolor": "#000fff",
                  "rate": 0.083
              },
              {
                  "level": 1,
                  "min": 10,
                  "max": 20,
                  "bgcolor": "#09e8ed",
                  "rate": 0.25
              },
              {
                  "level": 1,
                  "min": 20,
                  "max": 30,
                  "bgcolor": "#67ce0b",
                  "rate": 0.42
              },
              {
                  "level": 1,
                  "min": 30,
                  "max": 40,
                  "bgcolor": "#f2d62d",
                  "rate": 0.58
              },
              {
                  "level": 1,
                  "min": 40,
                  "max": 50,
                  "bgcolor": "#fa8a04",
                  "rate": 0.75
              },
              {
                  "level": 1,
                  "min": 50,
                  "max": 60,
                  "bgcolor": "#f80302",
                  "rate": 0.92
              },
              
          ]
      },
  ]
}

if (window.G_SENSOR_DATA_TYPE_INFO) {
  if (!window.G_SENSOR_DATA_TYPE_INFO.find(x=>x.value === 'stilt')) {
    window.G_SENSOR_DATA_TYPE_INFO.push(stiltInfo)
  }
}


function getHexOpacityColor({color = '#000',opacity = 0.5}){
  opacity = Math.max(opacity,0);
  opacity = Math.min(opacity,1);
  color = color.replace(/\#/g,'').toUpperCase();
  if(color.length === 3){
    let arr = color.split('');
    color = '';
    for (let i = 0; i < arr.length; i++) {
      color += (arr[i] + arr[i]);//将简写的3位字符补全到6位字符
    }
  }
  let num = Math.round(255 * opacity);//四舍五入
  let str = '';
  let arrHex = ["0","1","2","3","4","5","6","7","8","9","A","B","C","D","E","F"];//十六进制数组
  while (num>0) {
      let mod = num % 16;
      num = (num - mod) / 16;
      str = arrHex[mod] + str;
  }
  if(str.length == 1)str = '0' + str;
  if(str.length == 0)str = '00';
  return `#${color+str}`;
}


function interpolateGrid(grids) {
  let points = []
  for (let i of grids) {
    points.push({
      "type": "Feature",
      "properties": {
        "value": i[2]
      },
      "geometry": {
          "type": "Point",
          "coordinates": [
              i[0],
              i[1]
          ]
      }
    })
  }
  var collections = {
    type: "FeatureCollection",
    features: points
  }
  var options = { gridType: "points", property: "value", units: "degrees" };
  var grid = turf.interpolate(collections, 0.001, options);
  let newGrids = grid.features.map(x=>{
    return [...x.geometry.coordinates, x.properties.value]
  })
  console.log(newGrids);
  return newGrids
  
}

function stiltLayer(map) {
  var colors = ["#000fff","#09e8ed","#67ce0b","#f2d62d","#fa8a04","#f80302"]
  var show = true;
  var dataList = [];
  var trackTransparency = 1
  var canvasLayer = new CanvasLayer({
    map: map,
    update: update
  });

  function getData(station, mode, tm, trackTimeMode) {
    console.log(station, tm, trackTimeMode);
    let gcj = coordtransform.bd09togcj02(station.Lng, station.Lat)
    let wgsCoord = coordtransform.gcj02towgs84(gcj[0], gcj[1])
    let lng = Math.round(wgsCoord[0] * 10000)/10000
    let lat = Math.round(wgsCoord[1] * 10000)/10000

    // lat = 36.686075
    // lng = 117.061996
    if (mode) {
      // 聚合时间
      let [st, et] = tm
      const stStr = moment(st).subtract(8, 'hours').format('YYYY-MM-DD HH:mm:ss')
      const etStr = moment(et).subtract(8, 'hours').format('YYYY-MM-DD HH:mm:ss')
      axios.get(`http://jnwz.novaecs.com/167/napi/get-nc-data-range?st=${stStr}&et=${etStr}&lat=${lat}&lng=${lng}&high=2&coord_format=bd09&sid=${station.station_id}&val_mode=${trackTimeMode}`).then(x=>{
        console.log(x.data.data);
        dataList = x.data.data
        update()
      }).catch(e=>{
        dataList = []
        update()
        console.log(e);
        Message.info((e.data && e.data.msg) || '获取数据失败')
      })
    }else {
      // 时间点
      var tmStr = moment(tm).subtract(8, 'hours').format('YYYYMMDDHHmm')
      axios.get(`http://jnwz.novaecs.com/167/napi/get-nc-data?time=${tmStr}&lat=${lat}&lng=${lng}&high=2&coord_format=bd09`).then(x=>{
        console.log(x.data.data);
        dataList = x.data.data
        update()
      }).catch(e=>{
        dataList = []
        update()
        console.log(e);
        Message.info((e.data && e.data.msg) || '获取数据失败')
      })
    }
    
  }

  function getPix(lng, lat){
    return map.pointToPixel(new BMap.Point(lng, lat))
  }

  function getInten(max, min) {
    return new colorIntensity.getIntensity({
      dataType: 'stilt',
      max: max,
      min: min,
      colorType: 'static',
    });
  }

  function update() {
    let ctx = canvasLayer.canvas.getContext("2d");
    ctx.clearRect(0, 0, canvasLayer.canvas.width, canvasLayer.canvas.height);
    if (!show) return;
    if (!dataList.length) return;
    var unitH = 0.0005
    ctx.beginPath();
    ctx.globalAlpha = trackTransparency;
    let fd = dataList[0]
    let sd = dataList[1]
    let unit1 = fd[0] - sd[0]
    let unit2 = fd[1] - sd[1]
    unitH = unit1 !== 0 ? unit1 / 2 : unit2 / 2
    var maxVal = Math.min.apply(null, dataList.map(x=>x[2])) 
    var colorIntensity = getInten(0.01, 0)
    console.log('start draw');
    for (var i of dataList) {
      var color = colorIntensity.bgcolor.getColor(i[2]);
      // color = getHexOpacityColor({color: color, opacity: trackTransparency})
      // console.log(color);
      var center = i
      var p1 = getPix(center[0] - unitH, center[1] - unitH)
      // var p2 = getPix(center[0] - unitH, center[1] + unitH)
      var p3 = getPix(center[0] + unitH, center[1] + unitH)
      // var p4 = getPix(center[0] + unitH, center[1] - unitH)
      ctx.fillStyle=color; //线条颜色
      ctx.fillRect(p1.x,p1.y,p3.x-p1.x,p3.y-p1.y);
    }
    ctx.stroke();
    console.log('end draw');
  }
  var layer = {};
  layer.canvasLayer = canvasLayer;
  layer.hide = function() {
    console.log("hide");
    show = false;
    update();
  };
  layer.show = function() {
    console.log("show");
    show = true;
    update();
  };
  layer.destroy = () => {
    map.removeOverlay(canvasLayer)
  }
  layer.getData = getData
  layer.setOptions = (opts) => {
    trackTransparency = opts.transparency
    update()
  }
  return layer;
}


export { stiltLayer };



// WEBPACK FOOTER //
// ./src/utils/stiltLayer.js